/**
 * ============================================================================
 *                              crmss 版权声明
 * ============================================================================
 * 本软件系统（crmss - 快速开发通用管理后台框架）所有代码版权归 crmss 团队所有。
 * 代码中的 crmss 版权声明不允许删除和修改。
 * ============================================================================
 * 登录模块API接口 - 品牌管理平台
 */
import request from '@/utils/request'

/**
 * crmss 登录API标识
 */
export const CRMSS_LOGIN_API_FLAG = 'CRMSS_LOGIN_API'

/**
 * 登录请求参数接口
 */
export interface LoginParams {
  /** 手机号码 */
  phone: string
  /** 登录密码 */
  password: string
  /** 是否同意隐私政策 */
  agreePrivacy: boolean
  /** 是否同意用户协议 */
  agreeTerms: boolean
  /** 设备类型 */
  deviceType?: string
  /** 设备标识 */
  deviceId?: string
}

/**
 * 登录响应数据接口
 */
export interface LoginResult {
  /** 访问令牌 */
  accessToken: string
  /** 刷新令牌 */
  refreshToken: string
  /** 令牌类型 */
  tokenType: string
  /** 过期时间（秒） */
  expiresIn: number
  /** 用户信息 */
  userInfo: {
    userId: number
    account: string
    phone: string
    nickname: string
    avatar: string
    realName: string
    roleCode: string
    roleName: string
    deptId: number
    deptName: string
    platformType: string
  }
  /** crmss 响应标识 */
  crmssResponseType: string
}

/**
 * 用户登录 - 品牌管理平台
 * @param data 登录参数
 * @returns 登录结果
 */
export function loginApi(data: LoginParams) {
  return request({
    url: '/brand/auth/login',
    method: 'post',
    data
  })
}

/**
 * 用户登出
 * @returns 登出结果
 */
export function logoutApi() {
  return request({
    url: '/brand/auth/logout',
    method: 'post'
  })
}

/**
 * 刷新令牌
 * @param refreshToken 刷新令牌
 * @returns 新的登录信息
 */
export function refreshTokenApi(refreshToken: string) {
  return request({
    url: '/brand/auth/refresh',
    method: 'post',
    params: { refreshToken }
  })
}

/**
 * 获取当前登录用户信息
 * @returns 用户信息
 */
export function getUserInfoApi() {
  return request({
    url: '/brand/auth/userInfo',
    method: 'get'
  })
}

/**
 * 检查登录状态
 * @returns 登录状态
 */
export function checkLoginApi() {
  return request({
    url: '/brand/auth/check',
    method: 'get'
  })
}
